<template>
  <b-modal
    no-close-on-backdrop
    size="xl"
    hide-footer
    id="new_provider"
    title="NOVO FORNECEDOR"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a
            class="nav-link link-annotation-care-provider active"
            id="nav-informacoes"
            data-toggle="tab"
            href="#informacoes"
            role="tab"
            aria-controls="informacoes"
            aria-selected="true"
            >INFORMAÇÕES</a
          >
          <a
            class="nav-link link-annotation-care-provider"
            id="nav-endereco"
            data-toggle="tab"
            href="#endereco"
            role="tab"
            aria-controls="endereco"
            aria-selected="false"
            >ENDEREÇO</a
          >
          <a
            class="nav-link link-annotation-care-provider"
            id="nav-informacoes-bancaria"
            data-toggle="tab"
            href="#informacoes-bancaria"
            role="tab"
            aria-controls="informacoes-bancaria"
            aria-selected="false"
            >INFORMAÇÕES BANCÁRIA</a
          >
        </div>
      </nav>
      <div class="tab-content">
        <div
          class="tab-pane fade show active"
          id="informacoes"
          role="tabpanel"
          aria-labelledby="nav-informacoes"
        >
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-6 col-12">
              <label-required-field label="Nome/Razão social" />
              <input
                type="text"
                ref="autofocus"
                v-model="company_name"
                class="form-control"
              />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
              <label>Nome fantasia</label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="fantasy_name"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12">
              <b-checkbox
                class="mt-4 pt-3"
                v-model="is_foreign"
                :value="1"
                :unchecked-value="0"
              >
                <h6 class="my-0">Estrangeiro?</h6>
              </b-checkbox>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>I.E.</label>
              <input type="text" v-model="ie" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>I.M.</label>
              <input type="text" v-model="im" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>Telefone</label>
              <BInputPhone v-model="phone" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>E-mail</label>
              <input type="email" v-model="email" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>CPF/CNPJ</label>
              <input type="text" v-model="cpf_cnpj" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>CLASSIFICAÇÃO</label>
              <b-select v-model="provider_classification_id">
                <b-select-option value> SELECIONE </b-select-option>
                <b-select-option
                  v-for="classification in classifications"
                  :key="classification.id"
                  :value="classification.id"
                >
                  {{ classification.name }}
                </b-select-option>
              </b-select>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="endereco"
          role="tabpanel"
          aria-labelledby="nav-endereco"
        >
          <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
              <label>CEP</label>
              <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
            </div>
            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-8 col-12">
              <label>Endereço</label>
              <input type="text" v-model="address" class="form-control" />
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12">
              <label>Nº</label>
              <input
                type="text"
                v-model="number_address"
                class="form-control"
              />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>Complemento</label>
              <input type="text" v-model="complement" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>Bairro</label>
              <input type="text" v-model="neighborhood" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>Cidade</label>
              <input type="text" v-model="city" class="form-control" />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <label>Estado</label>
              <select v-model="uf_id" class="form-control">
                <option value>SELECIONE...</option>
                <option v-for="value in ufs" :key="value.id" :value="value.id">
                  {{ value.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="informacoes-bancaria"
          role="tabpanel"
          aria-labelledby="nav-informacoes-bancaria"
        >
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
              <label>Banco</label>
              <treeselect
                :multiple="false"
                :options="[
                  { id: '', label: 'SELECIONE...', children: [] },
                  ...banks,
                ]"
                placeholder="SELECIONE..."
                v-model="bank_id"
                noChildrenText="NÃO POSSUI BANCO(S) FILHO(S)"
              />
            </div>
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12">
              <label>Agência</label>
              <input type="text" v-model="agency" class="form-control" />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-12">
              <label>Conta</label>
              <input type="text" v-model="account" class="form-control" />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <label>Observação</label>
              <input type="text" v-model="note" class="form-control" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <warning-required-fields />
          <errors-messages :errors="errors" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../../Components/WarningRequiredFields";

import ErrorsMessages from "../../Components/ErrorsMessages";

import LabelRequiredField from "../../Components/LabelRequiredField";

import BInputCEP from "../../Components/BInputCEP";

import BInputPhone from "../../Components/BInputPhone";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "NewProvider",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
    BInputCEP,
    BInputPhone,
    Treeselect,
  },

  props: {
    defaultCompanyName: { type: String, required: false, default: "" },
    defaultCPFCNPJ: { type: String, required: false, default: "" },
  },

  data() {
    return {
      errors: [],
      loading: false,

      ufs: [],
      banks: [],
      classifications: [],

      //#region INFORMAÇÕES
      company_name: "",
      fantasy_name: "",
      is_foreign: 0,

      ie: "",
      im: "",
      phone: "",
      email: "",

      cpf_cnpj: "",
      provider_classification_id: "",
      //#endregion

      //#region ENDEREÇO
      cep: "",
      address: "",
      number_address: "",
      complement: "",
      neighborhood: "",
      city: "",
      uf_id: "",
      //#endregion

      //#region INFORMAÇÕES BANCÁRIAS
      bank_id: "",
      agency: "",
      account: "",
      note: "",
      //#endregion
    };
  },

  created() {
    this.evOnCreated();
  },

  methods: {
    async evOnShow() {
      //#region INFORMAÇÕES
      this.company_name = this.defaultCompanyName;
      this.fantasy_name = "";
      this.is_foreign = 0;

      this.ie = "";
      this.im = "";
      this.phone = "";
      this.email = "";

      this.cpf_cnpj = this.defaultCPFCNPJ;
      this.provider_classification_id = "";
      //#endregion

      //#region ENDEREÇO
      this.cep = "";
      this.address = "";
      this.number_address = "";
      this.complement = "";
      this.neighborhood = "";
      this.city = "";
      this.uf_id = "";
      //#endregion

      //#region INFORMAÇÕES BANCÁRIAS
      this.bank_id = "";
      this.agency = "";
      this.account = "";
      this.note = "";
      //#endregion
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnCreated() {
      if (this.errors.length === 0) await this.getClassifications();
      if (this.errors.length === 0) await this.getBanks();
      if (this.errors.length === 0) await this.getUFs();
    },

    async getClassifications() {
      try {
        this.loading = true;

        const params = { active: "1" };
        const response = await api.get("/rest-home/providers/classifications", {
          params,
        });
        const { error, errors, classifications } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.classifications = classifications;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getBanks() {
      try {
        this.loading = true;

        const response = await api.get("/banks");
        const { error, errors, banks } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.banks = banks;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getUFs() {
      try {
        this.loading = true;

        const response = await api.get("/ufs");
        const { error, errors, ufs } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.ufs = ufs;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          company_name: this.company_name,
          fantasy_name: this.fantasy_name,
          is_foreign: this.is_foreign,
          ie: this.ie,
          im: this.im,
          phone: this.phone,
          email: this.email,
          cpf_cnpj: this.cpf_cnpj,
          provider_classification_id: this.provider_classification_id,

          cep: this.cep,
          address: this.address,
          number_address: this.number_address,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          uf_id: this.uf_id,

          bank_id: this.bank_id,
          agency: this.agency,
          account: this.account,
          note: this.note,
        };
        const response = await api.post("/rest-home/provider", data);
        const { error, errors, message, provider_id } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_provider");
          this.$emit("created", provider_id);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },
  },
};
</script>

<style>
</style>